import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'

import useStyles from '../styles'

const UploadAdCreativeButton = ({ Icon, text, ...props }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <Button className={classes.uploadButton} {...props}>
      <Icon />
      {t(text)}
    </Button>
  )
}

UploadAdCreativeButton.propTypes = {
  Icon: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired
}

export default UploadAdCreativeButton
